module.exports = __webpack_public_path__ + "static/5-0d3a96dc2ef0c22e383f6bdfa7dc16f5.jpg";